import React from 'react';
import { JobMemberResponse } from '@doda/api-client/aspida/@types';
import { Text, LeftBorderTitle } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import styles from './index.module.scss';

export const DUMMY_IMAGE = '/DodaFront/Html/images/img_recruiter_001.png';

/**
 * MemberCardProps
 */
interface MemberCardProps extends JobMemberResponse {}

/**
 * 求人詳細 一緒に働くメンバーのモーダルのカード単体
 */
export const MemberCard: React.FC<MemberCardProps> = ({
  name,
  imageData,
  imageContentType,
  companyName,
  department,
  position,
  career,
}) => {
  return (
    <>
      <div className={styles['jobSearchDetail-memberCard__slide']}>
        <div className={styles['jobSearchDetail-memberCard__head']}>
          <div className={styles['jobSearchDetail-memberCard__imageContainer']}>
            <img
              className={styles['jobSearchDetail-memberCard__image']}
              src={
                imageData
                  ? `data:${imageContentType};base64,${imageData}`
                  : DUMMY_IMAGE
              }
              alt=""
            />
          </div>
          <div className={styles['jobSearchDetail-memberCard__text']}>
            <Text size="11">{companyName}</Text>
            <Text size="11">{department}</Text>
            <Text size="11">{position}</Text>
            <Text style={{ marginTop: '8px' }}>{name}</Text>
          </div>
        </div>
      </div>
      {career && (
        <>
          <LeftBorderTitle as="div">プロフィール</LeftBorderTitle>
          <div className={styles['jobSearchDetail-memberCard__profile']}>
            <TextWithLF text={career} />
          </div>
        </>
      )}
    </>
  );
};
